
import React from 'react';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '@/components/ui/table';
import { FeaturePreview } from '../FeaturePreview';
import { useTranslation } from 'react-i18next';

const sampleServices = [
  { name: 'Web Hosting', type: 'Recurring', cost: '$29.99', quantity: '1' },
  { name: 'SSL Certificate', type: 'One-time', cost: '$49.99', quantity: '1' },
];

export function ContractServicesPreview() {
  const { t } = useTranslation();
  
  const previewContent = (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{t('service', 'Service')}</TableHead>
            <TableHead>{t('type', 'Type')}</TableHead>
            <TableHead>{t('cost', 'Cost')}</TableHead>
            <TableHead>{t('quantity', 'Quantity')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sampleServices.map((service, index) => (
            <TableRow key={index}>
              <TableCell>{service.name}</TableCell>
              <TableCell>{service.type}</TableCell>
              <TableCell>{service.cost}</TableCell>
              <TableCell>{service.quantity}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );

  return (
    <FeaturePreview
      feature="contract_services"
      title={t('contractServices', 'Contract Services')}
      description={t('contractServicesDescription', 'Track and manage multiple services within each contract. Monitor costs, quantities, and service types efficiently.')}
      previewContent={previewContent}
      compact={true}
      translationLinks={[
        { key: 'contractServices', text: t('translateThis', 'Translate this') },
        { key: 'contractServicesDescription', text: t('translateDescription', 'Translate description') }
      ]}
    />
  );
}
